// extracted by mini-css-extract-plugin
export default {"unreadBadge":"UnreadMessages_unreadBadge__RE5Dw"};